var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article-layout',[_c('div',{staticClass:"subpage-top"},[_c('h1',[_vm._v("In de media")]),_c('router-link',{attrs:{"to":"/#media"}},[_vm._v("Terug")])],1),_c('plattelands'),_c('defile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }